import { render, staticRenderFns } from "./ImpersonationHeader.vue?vue&type=template&id=407e797b&scoped=true&"
import script from "./ImpersonationHeader.vue?vue&type=script&lang=ts&"
export * from "./ImpersonationHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ImpersonationHeader.vue?vue&type=style&index=0&id=407e797b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e797b",
  null
  
)

export default component.exports